import script from "./CountDown.vue?vue&type=script&setup=true&lang=js"
export * from "./CountDown.vue?vue&type=script&setup=true&lang=js"

import "./CountDown.vue?vue&type=style&index=0&id=466bc4f5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466bc4f5"]])

export default __exports__